export default {
    name: "Litecoin",
    nameAux: "Dogecoin",
    coin: "LTC",
    coinAux: "DOGE",
    scheme: "SOLO",
    account: 'LbhaFA9WRfjCes4Gt82YwSdfdhY1fTFa5E',
    accountAux: 'DJHWQfNXcNGnjQz4Rr8HTyDFtdeR2jWzW8',
    url: '',
    explorer_url: '',
    explorer: {
        address: 'https://chainz.cryptoid.info/ltc/address.dws?',
        height: 'https://chainz.cryptoid.info/ltc/block.dws?',
        hash: 'https://chainz.cryptoid.info/ltc/block.dws?',
        tx: 'https://chainz.cryptoid.info/ltc/tx.dws?',
    },
    explorerAux: {
        address: 'https://dogechain.info/address/',
        height: 'https://dogechain.info/block/',
        hash: 'https://dogechain.info/block/',
        tx: 'https://dogechain.info/tx/',
    },
    ports: [
        {
            info: 'LOW',
            host: 'molepool.com',
            port: 2601,
            diff: 65536,
        },
        {
            info: 'MID',
            host: 'molepool.com',
            port: 2602,
            diff: 1048576,
        },
        {
            info: 'HIGH',
            host: 'molepool.com',
            port: 2603,
            diff: 10223616,
        },
    ]
};